export enum AfterSaveActionEnum {
  ShowMessage,
  RedirectToEntriesView,
  ResetForm,
  RedirectToEntryView,
}
